import React, { Component } from 'react';
import './Footer.css';
import abcr from '../../assets/img/footer/abcr.png';
import promocao from '../../assets/img/footer/movimento-por-uma-cultura-de-doação.png';
import qrcode from '../../assets/img/footer/qr-code-footer.png';
import twitter from '../../assets/img/footer/twitter.svg';
import instagram from '../../assets/img/footer/instagram.svg';
import facebook from '../../assets/img/footer/facebook.svg';
import linkedin from '../../assets/img/footer/linkedin.svg';
import youtube from '../../assets/img/footer/youtube.svg';
import hiperlink from '../../assets/img/footer/partner-hiperlink.png';
import fundacao from '../../assets/img/footer/partner-fundacao.svg';
import gife from '../../assets/img/parceiros/Logo_GIFE_azul.png';
import MBM_Horizontal from '../../assets/img/parceiros/MBM_Logo_Vertical_Cor_RGB.png';
import MORRO_logo from '../../assets/img/parceiros/MORRO_logo_azul@3x.png';
import Mol from '../../assets/img/parceiros/Institito Mol - Vermelho.svg';
import { FormattedMessage } from 'react-intl';

export default class Footer extends Component {
  render() {
    let backers = this.props?.valor?.filter(partner => partner[4] == 'Apoiador');
    let partners = this.props?.valor?.filter(partner => partner[4] == 'Parceiro');

    console.log("aqui", this.props)
    return (
      <div className="container-footer">
        <div className="partner-title">
          <h3>
            <FormattedMessage id="backer-title" />
          </h3>
        </div>

        <div className="partner">
          {backers?.map((partner, index) => {
            return (
              <>
                <div key={'partner-' + index}>
                  <a href={partner[2]} target="_blank" rel="noopener noreferrer">
                    <img
                      src={partner[1]}
                      alt={partner[0]}
                      title={partner[0]}
                      style={partner[3] == 'Vertical' ? {height: "110px"} : {}}
                    />
                  </a>
                </div>
                {index % 3 === 2 && <div style={{width: '100%', height:'10px'}}>
                </div>}
              </>
            );
          })
          }
          {/* <div className="partner-one"></div> */}
          {/* <div>
            <a
              href="https://fundacaojles.org.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={fundacao}
                alt="parceiro fundação jles"
                title="Fundação"
              />
            </a>
          </div>
          <div>
            <a
              href="https://www.hiperlink.pro"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={hiperlink} alt="parceiro cocreare" title="Hiperlink" />
            </a>
          </div>
          <div>
            <a
              href="https://gife.org.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gife} alt="parceiro gife" title="GIFE" />
            </a>
          </div>
          <div style={{width: '100%', height:'10px'}}>

          </div>
          <div>
            <a
              href="https://movimentobemmaior.org.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={MBM_Horizontal} style={{height: "110px"}} alt="parceiro MBM" title="MBM" />
            </a>
          </div>
          <div>
            <a
              href="https://mdcenergia.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={MORRO_logo} style={{height: "110px"}} alt="parceiro MORRO" title="morro" />
            </a>
          </div>
          <div>
            <a
              href="https://institutomol.org.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Mol} alt="parceiro mol" title="mol" />
            </a>
          </div> */}
        </div>
        {partners?.length && <>
          <div className="partner-title">
            <h3>
              <FormattedMessage id="partner-title" />
            </h3>
          </div>
          <div className="partner">
            {partners?.map((partner, index) => {
              return (
                <>
                  <div key={'partner-' + index}>
                    <a href={partner[2]} target="_blank" rel="noopener noreferrer">
                      <img
                        src={partner[1]}
                        alt={partner[0]}
                        title={partner[0]}
                        style={partner[3] == 'Vertical' ? {height: "110px"} : {}}
                      />
                    </a>
                  </div>
                  {index % 3 === 2 && <div style={{width: '100%', height:'10px'}}>
                  </div>}
                </>
              );
            })
            }
          </div>
        </>}
        <div className="footer">
          <div className="footer-first">
            <div className="footer-first-promocao">
              <div className="footer-title">
                <h3>
                  <FormattedMessage id="footer-title-promotion" />
                </h3>
              </div>
              <div className="footer-img-promocao">
                <a
                  href="https://www.doar.org.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={promocao} alt="Promoção" />
                </a>
              </div>
            </div>

            <div className="footer-first-realizacao">
              <div className="footer-title">
                <h3>
                  <FormattedMessage id="footer-title-realization" />
                </h3>
              </div>
              <div className="footer-img-realizacao">
                <a
                  href="https://captadores.org.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={abcr} alt="ABCR" title="ABCR" />
                </a>
              </div>
            </div>

            <div className="footer-first-imprensa">
              <div className="footer-title">
                <h3>
                  <FormattedMessage id="footer-title-press" />
                </h3>
              </div>
              <div className="footer-description">
                <p>
                  <span className="footer-description-name">
                    DePropósito - Jessica Amaral
                  </span>
                </p>
                <a href="mailto:imprensa@depropositocomunica.com">
                  <p> imprensa@depropositocomunica.com </p>
                </a>
                <p> Tel: (41) 8824-3994 </p>
              </div>
            </div>
            <div className="footer-first-qrcode">
              <div className="footer-img-qrcode">
                <img src={qrcode} alt="QR Code" title="QR Code"></img>
              </div>
              <div className="footer-link">
                <span>
                  <strong>
                    <FormattedMessage id="footer-link-title" />
                  </strong>
                  <p>
                    <FormattedMessage id="footer-link-donation" />
                  </p>
                </span>
              </div>
            </div>
          </div>

          <div className="footer-secondary">
            <div className="footer-secondary-compartilhar">
              <a
                href="https://web.facebook.com/sharer.php?u=https%3A%2F%2Fwww.monitordasdoacoes.org.br&_rdc=1&_rdr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebook} alt="compartilhar" />
                <h4>
                  <FormattedMessage id="footer-secondary-compartilhar" />
                </h4>
              </a>
            </div>
            <div className="footer-secondary-sociais">
              <a
                href="https://instagram.com/abcrbrasil"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="instagram" />
              </a>
              <a
                href="https://twitter.com/abcrbrasil"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitter} alt="twitter" />
              </a>
              <a
                href="https://facebook.com/ABCRBrasil"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebook} alt="facebook" />
              </a>
              <a
                href="https://www.linkedin.com/company/abcr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedin} alt="linkedin" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCagSPBomjrVGxYuR3eUFyrQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={youtube} alt="youtube" />
              </a>
            </div>
            <div className="footer-secondary-compartilhar">
              <a
                href="https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fstatic.parastorage.com%2Fservices%2Fwix-bolt%2F1.5874.0%2Fnode_modules%2Fwix-santa%2Fstatic%2Fexternal%2Ftwitter.html%3FcompId%3Dcomp-k96bfxus%26href%3Dhttps%253A%252F%252Ftwitter.com%252Fshare%26lang%3Den%26origin%3Dhttps%253A%252F%252Fwww.monitordasdoacoes.org.br%26related%26text%26url%3Dhttp%253A%252F%252Fwww.monitordasdoacoes.org.br%26widgetType%3DTWEET&ref_src=twsrc%5Etfw&tw_p=tweetbutton&url=http%3A%2F%2Fwww.monitordasdoacoes.org.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitter} alt="tweet" />
                <h4>Tweet</h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
